import { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { Box, Typography } from "@maysoft/common-component-react";
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';

import Strings from "constants/strings";

import { IDataSeries } from ".";
import { NoDataIcon } from "components/DataNotFound";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        },
    },
};

const BarChartStatistic = ({
    title,
    total,
    dataSeries,
}: {
    total: number;
    title?: string
    dataSeries: IDataSeries[];
}) => {

    const dataFormat = useMemo(() => {
        let value: number[] = [];
        let color: string[] = [];
        let label: string[] = [];
        for (const element of [...dataSeries || []]) {
            value.push(element.value);
            color.push(element.color);
            label.push(element.textLabel);
        };
        return { value, color, label };
    }, [dataSeries]);

    const percentValue = (value: any, total: any) => {
        return Math.round((Number(value) / Number(total)) * 100) ? Math.round((Number(value) / Number(total)) * 100) : "0";
    };

    return (
        <Box sx={{ padding: 2 }}>
            {title &&
                <Typography variant="h6" sx={{ marginBottom: 1 }}>
                    {title}
                </Typography>
            }
            {(total === 0)
                ? (
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        height: "250px !important",
                        border: "1px solid #cdcdcd",
                        borderRadius: "4px",
                    }}>
                        <NoDataIcon color="#7b809a" />
                        <Typography variant="button" color="secondary">
                            {Strings.COMMON.NO_DATA}
                        </Typography>
                    </Box>
                )
                : (
                    <Box sx={{ height: "250px !important", }}>
                        <Bar
                            options={options}
                            data={{
                                labels: dataFormat.label,
                                datasets: [{
                                    label: "",
                                    data: dataFormat.value,
                                    backgroundColor: dataFormat.color,
                                }]
                            }}
                        />
                    </Box>
                )
            }
        </Box>
    );
};


export default BarChartStatistic;